module.exports = __webpack_public_path__ + "static/media/Florida Justice Reform Institute Logo.22997c98.jpeg";